/* GEHNA: "Shop by Price" dropdown in the header (desktop menu + mobile menu drawer).
   Theme-only: it does not change your Navigation menus. Edit LABEL / BASE / RANGES below to change it.
   Each range is [label, min price, max price]; use null for "no limit".
   The links use Shopify's price filter (?filter.v.price.gte=...&filter.v.price.lte=...), so the PRICE filter must be
   switched on for your collections (Shopify admin -> Apps -> Search & Discovery -> Filters). */
(function () {
  var LABEL = 'Shop by Price';
  var BASE = '/collections/all';
  var RANGES = [
    ['Under \u20b9300', null, 299],
    ['\u20b9300 - \u20b9499', 300, 499],
    ['\u20b9500 - \u20b9999', 500, 999],
    ['\u20b91000 - \u20b91999', 1000, 1999],
    ['\u20b92000 & Above', 2000, null]
  ];

  var CSS = ''
    + '.gx-price-li{position:relative}'
    + '.gx-price-chev{display:inline-block;margin-left:0.6rem;vertical-align:middle;transition:transform 0.2s ease}'
    + '.gx-price-li.gx-open .gx-price-chev{transform:rotate(180deg)}'
    + '.gx-price-menu{display:none;position:absolute;left:0;top:100%;z-index:60;min-width:20rem;margin:0;padding:0.8rem 0;list-style:none;background:#fff;border:1px solid #E6DFD6;border-radius:0.8rem;box-shadow:0 12px 32px rgba(36,31,28,0.14)}'
    + '.gx-price-li.gx-open .gx-price-menu{display:block}'
    + '@media screen and (min-width:990px){.gx-price-li:hover .gx-price-menu{display:block}.gx-price-li:hover .gx-price-chev{transform:rotate(180deg)}}'
    + '.gx-price-menu li{margin:0;padding:0}'
    + '.gx-price-menu a{display:block;padding:1.1rem 2rem;font-size:1.5rem;line-height:1.3;color:#241F1C;text-decoration:none;white-space:nowrap}'
    + '.gx-price-menu a:hover,.gx-price-menu a:focus-visible{background:#FAF8F5;color:#7A3E4D}'
    + '.gx-price-li--drawer .gx-price-menu{position:static;min-width:0;padding:0 0 0.8rem 2rem;background:transparent;border:0;border-radius:0;box-shadow:none}'
    + '.gx-price-li--drawer .gx-price-menu a{padding:1rem 0;font-size:1.5rem;white-space:normal}';
  var CHEV = '<svg class="gx-price-chev" viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>';

  function linkFor(r) {
    var q = [];
    if (r[1] != null) q.push('filter.v.price.gte=' + r[1]);
    if (r[2] != null) q.push('filter.v.price.lte=' + r[2]);
    return BASE + '?' + q.join('&');
  }

  function buildList(anchorClass) {
    var ul = document.createElement('ul');
    ul.className = 'gx-price-menu';
    RANGES.forEach(function (r) {
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = linkFor(r);
      a.textContent = r[0];
      if (anchorClass) a.className = anchorClass;
      li.appendChild(a);
      ul.appendChild(li);
    });
    return ul;
  }

  /* the last menu item that is a plain link (no dropdown of its own) - we copy its look */
  function lastPlainItem(list, linkSelector) {
    var kids = Array.prototype.slice.call(list.children);
    for (var i = kids.length - 1; i >= 0; i--) {
      var li = kids[i];
      if (li.classList.contains('gx-price-li')) continue;
      if (li.querySelector('details')) continue;
      if (li.querySelector(linkSelector)) return li;
    }
    return null;
  }

  function makeItem(ref, linkSelector, drawer) {
    var li = ref.cloneNode(true);
    li.removeAttribute('id');
    li.className = (li.className + ' gx-price-li' + (drawer ? ' gx-price-li--drawer' : '')).trim();
    var a = li.querySelector(linkSelector);
    a.setAttribute('href', '#');
    a.removeAttribute('id');
    a.removeAttribute('aria-current');
    a.classList.remove('header__active-menu-item', 'list-menu__item--active');
    var span = a.querySelector('span');
    if (span) span.textContent = LABEL;
    else a.textContent = LABEL;
    a.insertAdjacentHTML('beforeend', CHEV);
    a.setAttribute('aria-haspopup', 'true');
    a.setAttribute('aria-expanded', 'false');
    li.appendChild(buildList(drawer ? a.className : ''));

    a.addEventListener('click', function (e) {
      e.preventDefault();
      var open = li.classList.toggle('gx-open');
      a.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    return li;
  }

  function inject() {
    if (document.getElementById('gx-price-css')) return;
    var added = false;

    var dList = document.querySelector('.header__inline-menu > ul') || document.querySelector('.header__inline-menu ul');
    if (dList && !dList.querySelector('.gx-price-li')) {
      var ref = lastPlainItem(dList, 'a.header__menu-item, a.list-menu__item');
      if (ref) {
        dList.insertBefore(makeItem(ref, 'a.header__menu-item, a.list-menu__item', false), ref);
        added = true;
      }
    }

    var mList = document.querySelector('.menu-drawer__navigation .menu-drawer__menu') || document.querySelector('.menu-drawer__menu');
    if (mList && !mList.querySelector('.gx-price-li')) {
      var mref = lastPlainItem(mList, 'a.menu-drawer__menu-item, a');
      if (mref) {
        mList.insertBefore(makeItem(mref, 'a.menu-drawer__menu-item, a', true), mref);
        added = true;
      }
    }

    if (added) {
      var st = document.createElement('style');
      st.id = 'gx-price-css';
      st.textContent = CSS;
      document.head.appendChild(st);
    }
  }

  /* close the dropdown when tapping outside of it */
  document.addEventListener('click', function (e) {
    document.querySelectorAll('.gx-price-li.gx-open').forEach(function (li) {
      if (!li.contains(e.target)) {
        li.classList.remove('gx-open');
        var a = li.querySelector('a[aria-haspopup]');
        if (a) a.setAttribute('aria-expanded', 'false');
      }
    });
  });

  document.addEventListener('DOMContentLoaded', inject);
  window.addEventListener('load', inject);
  inject();
  setTimeout(inject, 500);
  setTimeout(inject, 1500);
})();
